var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-sidebar",class:{ 'app-bar-collapsed': _vm.appBarCollapsed }},[_c('ul',{staticClass:"section-sidebar-nav"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }